import { useMemo } from 'react';
import LandingPage from 'Components/LandingPage';
import ForgotPasswordPage from 'Components/auth/ForgotPassword';
import LoginPage from 'Components/auth/Login';
import ResetPasswordPage from 'Components/auth/ResetPassword';
import Consents from 'Components/consents/ConsentsScreen';
import Document from 'Components/consents/Document';
import HipaaConsent from 'Components/consents/HipaaConsent';
import LibreAssistConsent from 'Components/consents/LibreAssistConsent';
import NoticesConsents from 'Components/consents/NoticesConsents';
import RWEConsent from 'Components/consents/RWEConsent';
import VerifyConsents from 'Components/consents/VerifyConsents';
import RegisterPage from 'Components/register/CreateNewUser';
import AccountInformation from 'Components/settings/AccountInformation';
import UpdatePasswordPage from 'Components/settings/UpdatePassword';
import { InitializationErrorPage } from 'Components/utility/InitializationErrorPage';
const routes = [
    { route: 'login', component: LoginPage },
    { route: 'create-account', component: RegisterPage },
    { route: 'forgot-password', component: ForgotPasswordPage },
    { route: 'reset-password', component: ResetPasswordPage },
    { route: 'account-information', component: AccountInformation },
    { route: 'update-password', component: UpdatePasswordPage },
    { route: 'hipaa', component: HipaaConsent },
    { route: 'rwe', component: RWEConsent },
    { route: 'assist', component: LibreAssistConsent },
    { route: 'terms-of-use', component: Document, props: { type: 'termsOfUse' } },
    { route: 'privacy-notice', component: Document, props: { type: 'privacyNotice' } },
    { route: 'verify-consents', component: VerifyConsents },
    { route: 'notices-consents', component: NoticesConsents },
    { route: 'consents', component: Consents },
];
const useRouter = (location, queryString, initErrorStatus) => {
    const { Component, props } = useMemo(() => {
        if (initErrorStatus) {
            return {
                Component: InitializationErrorPage,
                props: { errorStatus: initErrorStatus, navigationQueryString: queryString },
            };
        }
        const lowerCaseLocation = location.toLowerCase();
        const route = routes.find((r) => lowerCaseLocation.startsWith(`/${r.route.toLowerCase()}`));
        if (route) {
            return { Component: route.component, props: route.props };
        }
        return { Component: LandingPage };
    }, [initErrorStatus, location, queryString]);
    return { Component, props };
};
export default useRouter;
